module.exports = __webpack_public_path__ + "2e7328e087620c7623e394696194b096.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/key-art-768.webp.png
// module id = 434
// module chunks = 0